













































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
// service methods
import { getChannelResolutions, getFilteredChannels } from "@/services/channels/channelsService";
import { getSolutions } from "@/services/solutions/solutionService";
// types
import { Channel, ChannelsFilterDtoIn } from "@/services/channels/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { channelsModalFields } from "@/components/channels/fields/channelsModalFields";
import { GetLocalizedItemTypes } from "@/components/posts/PostTypeRegister";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree
    }
})
export default class SelectChannelModal extends Vue {
    @Prop() id!: string;
    // @Prop({ default: "" }) private instance!: string;
    // local state
    channels = [] as Array<Channel>;
    fields = channelsModalFields;
    isBusy = false;

    // folders
    folderEntity = FolderEntites.Channels;
    // instance = ""; // (Math.random() * 10).toString(); // "SelectChannelModal";
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedSolution = null as Option | any;
    filterResolution = "" as string;
    filterPostType = "";
    // filter options
    solutions = [] as Array<Option>;
    searchText = "" as string;
    resolutions = [] as Array<String>;
    selectedChannels = [] as Channel[];
    multiPicker = false;
    searchTimer = 0;

    open(multiPicker = false) {
        this.multiPicker = multiPicker;
        this.resetState();
        this.fetchData();
        this.$bvModal.show(this.id);
    }

    rowSelected(items: Channel[]) {
        this.selectedChannels = items;
    }

    save() {
        this.$emit("select", this.selectedChannels.map(x => {
            return {
                id: x.id,
                name: x.name
            };
        }));
        this.$bvModal.hide(this.id);
    }

    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
        this.loadChannels();
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    // methods
    fetchData() {
        getSolutions().then(response => {
            this.solutions = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
        getChannelResolutions().then(response => {
            this.resolutions = response;
        });
    }

    loadChannels() {
        this.isBusy = true;
        this.channels = [] as Array<Channel>;
        getFilteredChannels({
            solutionId: this.selectedSolution ? this.selectedSolution.id : "",
            folderId: this.selectedFolderNode ? this.selectedFolderNode.id : "",
            resolution: this.filterResolution ? this.filterResolution : "",
            postType: this.filterPostType ? this.filterPostType : "",
            search: this.searchText
        } as ChannelsFilterDtoIn).then(response => {
            this.channels = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedSolution = null;
        this.filterResolution = "";
        this.filterPostType = "";
        this.loadChannels();
    }

    clearSearch() {
        this.searchText = "";
        this.loadChannels();
    }

    resetState() {
        this.selectedSolution = null;
        this.searchText = "";
        this.filterResolution = "";
        this.filterPostType = "";
    }

    filterText() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.loadChannels(), 1000);
    }

    onHidden() {
        this.resetState();
        clearTimeout(this.searchTimer);
        this.channels = [];
    }
    // computed and watchers

    get filterActive(): boolean {
        return (
            (this.selectedSolution && Object.keys(this.selectedSolution.id).length > 0) ||
            this.searchText !== "" ||
            (!!this.filterResolution && this.filterResolution !== "") ||
            (!!this.filterPostType && this.filterPostType !== ""));
    }

    get postTypes() {
        return GetLocalizedItemTypes();
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }
}
